<div class="d-flex justify-content-between position-relative">
  <input [formControl]="searchString" [placeholder]="placeholder"/>
  <img src="assets/images/icons-2/Icon_search.svg" alt="Search" class="search-icon"/>
</div>

